// Shared Recharts styling so charts across the app look cohesive and modern
// instead of the default flat lines. Provides: a palette, clean axis/grid
// props, a card-style tooltip, and gradient <defs> for area fills.
import React from 'react';

export const PALETTE = [
  '#2563EB', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6',
  '#06B6D4', '#EC4899', '#14B8A6', '#F97316', '#6366F1',
];

// Subtle horizontal-only grid; vertical lines tend to look noisy.
export const gridProps = { strokeDasharray: '4 4', stroke: '#eef2f7', vertical: false };
export const axisX = { tick: { fontSize: 11, fill: '#94a3b8' }, axisLine: { stroke: '#e2e8f0' }, tickLine: false, tickMargin: 8 };
export const axisY = { tick: { fontSize: 11, fill: '#94a3b8' }, axisLine: false, tickLine: false, width: 38 };

// White rounded tooltip with a colour swatch per series.
export function ChartTooltip({ active, payload, label, labelFormatter, valueSuffix = '' }) {
  if (!active || !payload || !payload.length) return null;
  return (
    <div style={{
      background: '#fff', border: '1px solid #e2e8f0', borderRadius: 10,
      boxShadow: '0 8px 24px rgba(15,23,42,0.12)', padding: '8px 12px', fontSize: 12, minWidth: 120,
    }}>
      {label != null && label !== '' && (
        <div style={{ fontWeight: 700, color: '#0f172a', marginBottom: 6 }}>
          {labelFormatter ? labelFormatter(label) : label}
        </div>
      )}
      {payload.map((p, i) => (
        <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '2px 0' }}>
          <span style={{ width: 9, height: 9, borderRadius: 3, background: p.color || p.stroke || p.fill, flexShrink: 0 }} />
          <span style={{ color: '#64748b', flex: 1, whiteSpace: 'nowrap' }}>{p.name}</span>
          <span style={{ fontWeight: 700, color: '#0f172a' }}>
            {typeof p.value === 'number' ? p.value.toLocaleString() : p.value}{valueSuffix}
          </span>
        </div>
      ))}
    </div>
  );
}

// <AreaGradients series={[{ id:'gScanned', color:'#10B981' }, ...]} /> — drop
// inside an AreaChart, then reference fill="url(#gScanned)".
export function AreaGradients({ series }) {
  return (
    <defs>
      {series.map(s => (
        <linearGradient key={s.id} id={s.id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={s.color} stopOpacity={0.30} />
          <stop offset="100%" stopColor={s.color} stopOpacity={0.02} />
        </linearGradient>
      ))}
    </defs>
  );
}
